import {
  MOUNT,
  UNMOUNT,
  UPDATE_ACTIVE_DIALOG,
  POST_PID_SYNC,
  POST_PID_SYNC_START,
  POST_PID_SYNC_SUCCESS,
  POST_PID_SYNC_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const mount = () => ({ type: MOUNT })
const unmount = () => ({ type: UNMOUNT })
const setActiveDialog = () => ({ type: UPDATE_ACTIVE_DIALOG, active: true })
const setInactiveDialog = () => ({ type: UPDATE_ACTIVE_DIALOG, active: false })
const postPidSync = () => ({ type: POST_PID_SYNC })
const postPidSyncStart = () => ({ type: POST_PID_SYNC_START })
const postPidSyncSuccess = () => ({ type: POST_PID_SYNC_SUCCESS })
const postPidSyncError = (error) => ({ type: POST_PID_SYNC_ERROR, error })
const startPostPidSyncAsync = buildAsyncAction(
  POST_PID_SYNC,
  POST_PID_SYNC_START,
  [POST_PID_SYNC_ERROR, POST_PID_SYNC_SUCCESS]
)

export {
  mount,
  unmount,
  setActiveDialog,
  setInactiveDialog,
  postPidSync,
  postPidSyncStart,
  postPidSyncSuccess,
  postPidSyncError,
  startPostPidSyncAsync,
}
